import type { CommitteeAssignmentStatus } from "./types";

export type AssignmentDisplayStatus = "ACTIVE" | "INACTIVE" | "PLANNED";
export type AssignmentDisplayStatusLabel = "Active" | "Inactive" | "Planned";

export function getAssignmentDisplayStatus(
  assignment: {
    status?: CommitteeAssignmentStatus;
    startDate: string | null;
    endDate?: string | null;
  },
  todayIso: string
): AssignmentDisplayStatus {
  if (assignment.endDate && assignment.endDate < todayIso) return "INACTIVE";
  if (assignment.startDate && assignment.startDate > todayIso) return "PLANNED";
  if (assignment.status === "INACTIVE") return "INACTIVE";
  return "ACTIVE";
}

export const ASSIGNMENT_DISPLAY_STATUS_LABELS: Record<AssignmentDisplayStatus, AssignmentDisplayStatusLabel> = {
  ACTIVE: "Active",
  INACTIVE: "Inactive",
  PLANNED: "Planned"
};

export const ASSIGNMENT_DISPLAY_STATUS_TAG_TYPES: Record<
  AssignmentDisplayStatus,
  "success" | "surface" | "information"
> = {
  ACTIVE: "success",
  INACTIVE: "surface",
  PLANNED: "information"
};
